import React from 'react';
import { DonutLegendChart } from '@/components/ui/DonutLegendChart';

export function ProjectLogsStats() {
  const statsData = [
    { name: 'Công việc', value: 98, color: '#3b82f6' },
    { name: 'Tài liệu', value: 45, color: '#10b981' },
    { name: 'Vật tư', value: 34, color: '#f59e0b' },
    { name: 'Chi phí', value: 28, color: '#a855f7' },
    { name: 'Kiểm tra', value: 22, color: '#06b6d4' },
    { name: 'Sự cố', value: 10, color: '#f43f5e' },
    { name: 'Khác', value: 8, color: '#94a3b8' },
  ];

  return (
    <DonutLegendChart
      title="Hoạt động theo loại"
      centerValue={245}
      centerLabel="Tổng hoạt động"
      data={statsData}
      total={245}
    />
  );
}
